import { GENERIC_HTTP_ERR_MESSAGES, HTTP_RESPONSES } from "./http-responses"

export const PRODUCTS_HTTP_ERR_RESPONSES_MESSAGES = {
  ...GENERIC_HTTP_ERR_MESSAGES,
  [HTTP_RESPONSES.BadRequest]: "Esse produto já existe",
  [HTTP_RESPONSES.Unauthorized]: "Você não tem autorização",
  [HTTP_RESPONSES.UnprocessableEntity]: "Os campos são inválidos",
  [HTTP_RESPONSES.InternalServerError]: "Algum erro ocorreu..."
}

// Client error
export const ALL_FIELDS_REQUIRED = "Todos os campos são obrigatórios"
export const INVALID_PREFIX_URL = "O prefixo deve conter apenas letras minúsculas"
export const LARGE_PREFIX_URL = "Prefixo muito grande"
export const LARGE_NAME = "Nome muito grande"
